"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Servis i Obnova Baterija",
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576390/img/pcb_repair_service.png)]",
  link: "/BatteryServicePage"
}, {
  title: "Mehanički Popravci i Gume",
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576390/img/forklift_controls_service.png)]",
  link: "/ServicesPage"
}, {
  title: "Elektronika i Dijagnostika",
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576390/img/battery_chargers_service.png)]",
  link: "/ServicesPage"
}];
export default function OnzeReparatiediensten() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224820" id="katalog-servisnih-usluga" className="bg-background text-foreground py-24">
            <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold font-default text-primary mb-4">
                        Katalog servisnih usluga
                    </h2>
                    <p className="text-muted-foreground font-default max-w-2xl mx-auto">
                        Profesionalni servis za popravak, dijagnostiku i obnovu električnih romobila. Specijalizirani smo za baterijske sustave i vrhunske mehaničke popravke.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {services.map((service, i) => <Card key={i} data-index={i} className="relative overflow-hidden group h-[400px] border-none rounded-lg p-0 bg-transparent shadow-lg">
                            {}
                            <div className={`absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105 ${service.bgClass}`} />

                            {}
                            <div className="absolute inset-0 bg-primary/85 transition-colors duration-500 group-hover:bg-primary/60 backdrop-blur-[2px]" />

                            {}
                            <div className="absolute inset-0 p-8 flex flex-col justify-end">
                                <h3 className="text-2xl font-bold font-default text-white mb-4 transform transition-transform duration-500 group-hover:-translate-y-4">
                                    {service.title}
                                </h3>

                                {}
                                <div className="overflow-hidden">
                                    <div className="transform translate-y-[150%] opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                                        <Button asChild variant="default" className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 transition-all shadow-md">
                                            <Link to={service.link}>
                                                Saznajte više <ArrowRight className="ml-2 w-4 h-4" />
                                            </Link>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Card>)}
                </div>
            </div>
        </section>;
}